import { saveToStorage } from "./utilities";

function storePrintValues({
    aheadOfInflation,
    balancedFutureValue,
    behindInflation,
    cashFutureValue,
    initialInvestment,
    projectedCost,
    timePeriod,
}) {
    timePeriod = timePeriod.trim().toLowerCase();

    const value = {
        aheadOfInflation,
        balancedFutureValue,
        behindInflation,
        cashFutureValue,
        initialInvestment,
        projectedCost,
        timePeriod,
    };

    saveToStorage("inflation", value);
}

export { storePrintValues };
